import AppContext from 'App/AppContext';
import { IPText, IPTooltipHost } from 'baseComponents';
import { IPStack } from 'baseComponents/Stack/IPStack';
import { globalFontBoldWeight, globalStackTokensGapExtraSmall } from 'globalStyles';
import ResourceLink, {
  PublishingStateResourceLink,
  PublishingStateSharePoint,
  ResourceLinkPublishingState,
} from 'models/resourceLink';
import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FeatureTypes, hasSubscriptionFeature } from 'services/Auth/featurePermissions';
import { getPublicationStateIcon } from './Helpers/LinkIcons';

interface IPublishingStateProps {
  version: string | undefined;
  publishingState: ResourceLinkPublishingState | undefined;
  iconColor?: string;
  textColor?: string;
  showFullText?: boolean;
}

const PublishingState = (props: IPublishingStateProps) => {
  const appContext = useContext(AppContext);
  const { t } = useTranslation(['translation', 'library']);
  const [hasReadConfirmationFeature] = useState<boolean>(
    hasSubscriptionFeature(appContext.user.login.subscriptionType, FeatureTypes.ReadConfirmations),
  );

  //
  // Main render
  //

  //Show nothing if no version
  if (!props.version) return null;

  //Show only version if no publishing state
  if (props.publishingState === undefined || props.publishingState === PublishingStateSharePoint.None) {
    return (
      <IPText styles={{ root: { color: props.textColor, fontWeight: globalFontBoldWeight } }}>{props.version}</IPText>
    );
  }

  //Adjust publishing state if feature is not available (Basic/NIS2 subscriptions)
  let publishingStateToShow = props.publishingState;
  if (!hasReadConfirmationFeature && props.publishingState === PublishingStateResourceLink.ToBePublished) {
    publishingStateToShow = PublishingStateSharePoint.Published;
  }

  if (props.showFullText) {
    return (
      <IPStack horizontal tokens={globalStackTokensGapExtraSmall} verticalAlign="center">
        <IPText styles={{ root: { color: props.textColor, fontWeight: globalFontBoldWeight } }}>{props.version}</IPText>
        <IPText>{ResourceLink.getPublicationStateText(publishingStateToShow, t)}</IPText>
        {getPublicationStateIcon(publishingStateToShow, props.iconColor)}
      </IPStack>
    );
  } else {
    return (
      <IPTooltipHost content={ResourceLink.getPublicationStateText(publishingStateToShow, t)}>
        <IPStack horizontal tokens={globalStackTokensGapExtraSmall} verticalAlign="center">
          <IPText styles={{ root: { color: props.textColor, fontWeight: globalFontBoldWeight } }}>
            {props.version}
          </IPText>
          {getPublicationStateIcon(publishingStateToShow, props.iconColor)}
        </IPStack>
      </IPTooltipHost>
    );
  }
};

export default PublishingState;
